var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsideLeft',{staticClass:"category hidden lg:block"},[_c('template',{slot:"title"},[_vm._v(" Alle Kategorien ")]),_vm._v(" "),_vm._l((_vm.productCategories),function(category){return _c('li',{key:category.id,staticClass:"transition"},[_c('nuxt-link',{class:{
        'nuxt-link-exact-active': _vm.$route.fullPath.startsWith(
          '/shop?categories=' + category.slug
        ),
      },attrs:{"to":'/shop?categories=' + category.slug}},[_vm._v("\n      "+_vm._s(category.title)+"\n    ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }